import { createSlice } from '@reduxjs/toolkit';

export const WATERMARK_REMOVER_USE_CREDIT = 5;

export const FJSliceWatermarkRemover = createSlice({
    name: 'watermarkRemover',
    initialState: {
        inputImageInfo: null,
    },
    reducers: {
        setSliceInputImageInfo: (state, action) => {
            state.inputImageInfo = action.payload;
        },
    },
});

export const {
    setSliceInputImageInfo,
} = FJSliceWatermarkRemover.actions;

export default FJSliceWatermarkRemover.reducer; 